import { Stack } from "types/generated";
import { useBulkStackSyncCommit } from "shared/Stack/useSyncCommit";
import useCanSyncCommit from "shared/Stack/access/useCanSyncCommit";

import { StackBulkActions } from "../types";
import { BULK_ACTION_NAMES, BULK_ACTION_RESULTS_TITLE } from "../constants";

const useSyncCommitBulkAction = () => {
  const [syncCommit] = useBulkStackSyncCommit();

  const canSyncCommit = useCanSyncCommit();

  return {
    key: StackBulkActions.SyncCommit,
    title: BULK_ACTION_NAMES[StackBulkActions.SyncCommit],
    resultTitle: BULK_ACTION_RESULTS_TITLE[StackBulkActions.SyncCommit],
    condition: (stack: Stack) => canSyncCommit(stack),
    mutation: (stack: Stack) => syncCommit({ id: stack.id }),
  };
};

export default useSyncCommitBulkAction;
